import { OpenAPISpec, ParsedEndpoint } from "../types";

export function parseEndpoints(spec: OpenAPISpec): ParsedEndpoint[] {
  const endpoints: ParsedEndpoint[] = [];
  if (!spec.paths) return endpoints;

  for (const [path, methods] of Object.entries(spec.paths)) {
    for (const [method, operation] of Object.entries(methods)) {
      if (
        ["get", "post", "put", "delete", "patch", "options", "head"].includes(
          method.toLowerCase(),
        )
      ) {
        const tags =
          operation.tags && operation.tags.length > 0
            ? operation.tags
            : ["default"];
        for (const tag of tags) {
          endpoints.push({
            id: `${method}-${path}-${tag}`,
            path,
            method: method.toUpperCase(),
            operation,
            tag,
          });
        }
      }
    }
  }
  return endpoints;
}

export function resolveRef(spec: any, ref: string): any {
  if (!ref || !ref.startsWith("#/")) return null;
  const parts = ref.replace("#/", "").split("/");
  let current = spec;
  for (const part of parts) {
    if (current && current[part] !== undefined) {
      current = current[part];
    } else {
      return null;
    }
  }
  return current;
}

export function generateExampleFromSchema(
  schema: any,
  spec: any,
  level = 0,
): any {
  if (!schema || level > 5) return ""; // Prevent infinite recursion
  let resolved = schema;
  if (schema.$ref) {
    resolved = resolveRef(spec, schema.$ref) || schema;
  }

  if (resolved.example !== undefined) return resolved.example;
  if (resolved.default !== undefined) return resolved.default;

  if (resolved.type === "object" || resolved.properties) {
    const obj: any = {};
    for (const [key, prop] of Object.entries(resolved.properties || {})) {
      obj[key] = generateExampleFromSchema(prop, spec, level + 1);
    }
    return obj;
  }

  if (resolved.type === "array") {
    return [generateExampleFromSchema(resolved.items, spec, level + 1)];
  }

  switch (resolved.type) {
    case "string":
      if (resolved.format === "date-time") return new Date().toISOString();
      if (resolved.format === "date")
        return new Date().toISOString().split("T")[0];
      if (resolved.format === "uuid")
        return "3fa85f64-5717-4562-b3fc-2c963f66afa6";
      if (resolved.format === "email") return "user@example.com";
      return "string";
    case "number":
    case "integer":
      return 0;
    case "boolean":
      return true;
    default:
      return "";
  }
}
